import { changetheme } from '@/store/layout/layout-action'
import type { LayoutState } from '@/store/layout/layout-reducers'
import { getLayoutColor } from '@/store/layout/layout-selector'
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  inject,
  Input,
  Output,
  type OnInit,
  ChangeDetectionStrategy
} from '@angular/core'
import { RouterLink } from '@angular/router'
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngrx/store'
import { LogoBoxComponent } from '@components/logo-box.component'
import { credits } from '@common/constants'
import { User } from '@/store/authentication/auth.model'
import { getUser } from '@/store/authentication/authentication.selector'
import { OpenAuthenticationService } from '@core/services/oauth.service'

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [NgbDropdownModule, RouterLink, LogoBoxComponent],
  templateUrl: './topbar.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``,
})
export class TopbarComponent implements OnInit {
  @Input() title!: string
  @Input() subTitle!: string
  @Output() mobileMenuButtonClicked = new EventEmitter()

  store = inject(Store)
  authService = inject(OpenAuthenticationService)

  breadcrumbRoot!: string
  color!: string
  user!: User | null

  ngOnInit(): void {
    this.breadcrumbRoot = credits.platformName
    this.store.select('layout').subscribe((data: LayoutState) => {
      this.color = data.LAYOUT_THEME
    })
    this.store.select(getUser).subscribe((user) => {
      this.user = user
    })
  }

  toggleMobileMenu() {
    this.mobileMenuButtonClicked.emit()
  }

  changeTheme() {
    const color = document.documentElement.getAttribute('data-bs-theme')
    if (color == 'light') {
      this.store.dispatch(changetheme({ color: 'dark' }))
    } else {
      this.store.dispatch(changetheme({ color: 'light' }))
    }
    this.store.select(getLayoutColor).subscribe((color) => {
      document.documentElement.setAttribute('data-bs-theme', color)
    })
  }

  logout() {
    // End-session redirect to Identity + local state cleared (the service dispatches the store logout).
    this.authService.logout()
  }
}
